import { faqTypes } from './faq.types';

const INITIAL_ON_EDIT_FAQ = {
  channelId: '',
  faqTitle: '',
  faqId: '',
  faqDescription: '',
  isFAQEnabled: true,
  loading: false,
  questions: [],
};

const INITIAL_STATE = {
  faq: {
    channelId: '',
    total: null,
    page: 1,
    pageSize: 10,
    data: [],
    loading: false,
    loadingMore: false,
  },
  // faq in add page
  onEditFAQ: INITIAL_ON_EDIT_FAQ,
};

const faqReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case faqTypes.FETCH_FAQ_LIST_START:
      return {
        ...state,
        faq: {
          ...state.faq,
          loading: true,
        },
      };

    case faqTypes.SET_FAQ_LIST:
      return {
        ...state,
        faq: {
          ...state.faq,
          loading: false,
          data: action.payload,
        },
      };

    case faqTypes.UPDATE_FAQ_ENABLE_START: {
      const { faqId } = action.payload;
      const updatedFAQList = state.faq.data.map((item) => {
        if (item.id === faqId) {
          return { ...item, isLoadingToggleStatus: true };
        }

        return item;
      });
      return { ...state, faq: { ...state.faq, data: updatedFAQList } };
    }

    case faqTypes.SET_UPDATED_FAQ: {
      const { faqId, updatedFields } = action.payload;
      const updatedFAQList = state.faq.data.map((item) => {
        if (item.id === faqId) {
          return { ...item, ...updatedFields, isLoadingToggleStatus: false };
        }

        return item;
      });
      return { ...state, faq: { ...state.faq, data: updatedFAQList } };
    }

    case faqTypes.SET_ON_EDIT_FAQ: {
      return {
        ...state,
        onEditFAQ: {
          ...state.onEditFAQ,
          ...action.payload,
        },
      };
    }

    case faqTypes.CREATE_EMPTY_QUESTION: {
      const newQuestion = {
        questionId: undefined,
        // temporary id
        tempId: new Date().getTime(),
        order: state.onEditFAQ.questions.length + 1,
        question: '',
        answer: '',
        faqId: state.onEditFAQ.faqId,
        isExpanded: true,
      };

      return {
        ...state,
        onEditFAQ: {
          ...state.onEditFAQ,
          questions: [...state.onEditFAQ.questions, newQuestion],
        },
      };
    }

    case faqTypes.SET_ON_EDIT_QUESTION: {
      const { tempId, data } = action.payload;
      const newQuestions = state.onEditFAQ.questions.map((item) => {
        if (item.tempId === tempId) {
          return { ...item, ...data };
        }

        return item;
      });

      return {
        ...state,
        onEditFAQ: {
          ...state.onEditFAQ,
          questions: newQuestions,
        },
      };
    }

    case faqTypes.SET_QUESTIONS_LIST: {
      return {
        ...state,
        onEditFAQ: {
          ...state.onEditFAQ,
          questions: action.payload,
        },
      };
    }

    case faqTypes.SET_PAGE_AND_PAGESIZE_DATA: {
      return {
        ...state,
        faq: {
          ...state.faq,
          ...action.payload,
        },
      };
    }

    case faqTypes.SET_QUESTION_DATA: {
      const { tempId, ...data } = action.payload;

      const updatedQuestions = state.onEditFAQ.questions.map((item) => {
        if (item.tempId === tempId) {
          return { ...item, ...data };
        }

        return item;
      });

      return {
        ...state,
        onEditFAQ: {
          ...state.onEditFAQ,
          questions: updatedQuestions,
        },
      };
    }

    case faqTypes.RESTART_ON_EDIT_FAQ: {
      return {
        ...state,
        onEditFAQ: INITIAL_ON_EDIT_FAQ,
      };
    }

    case faqTypes.TOGGLE_QUESTION_EXPAND: {
      const tempId = action.payload;
      const newQuestionsList = state.onEditFAQ.questions.map((q) => {
        if (q.tempId === tempId) {
          return { ...q, isExpanded: !q.isExpanded };
        }

        return q;
      });

      return {
        ...state,
        onEditFAQ: {
          ...state.onEditFAQ,
          questions: newQuestionsList,
        },
      };
    }

    case faqTypes.FETCH_SINGLE_FAQ_START: {
      return {
        ...state,
        onEditFAQ: {
          ...state.onEditFAQ,
          loading: true,
        },
      };
    }

    case faqTypes.DELETE_FAQ: {
      const { faqId } = action.payload;
      const filteredList = state.faq.data.filter((item) => item.id !== faqId);
      return { ...state, faq: { ...state.faq, data: filteredList } };
    }

    default:
      return state;
  }
};

export default faqReducer;
